var _rect, _rect2, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundFlagBr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fnh1v2ohea)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#039"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "8h8dpefscb",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#8h8dpefscb)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.046 25.263H-2.309c-.12 0-.217-.14-.217-.312V-.95c0-.172.097-.312.217-.312h27.355c.12 0 .217.14.217.312v25.902c0 .172-.097.312-.217.312z",
    fill: "#4BA543"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.737 2.526v18.948h2.2c.18 0 .326-.1.326-.223V2.749c0-.123-.146-.223-.327-.223h-2.2z",
    fill: "#43A047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.361 11.827 11.87 5.09a.246.246 0 0 1 .262 0l10.508 6.737c.13.084.13.262 0 .346L12.13 18.91a.245.245 0 0 1-.262 0L1.36 12.173a.201.201 0 0 1 0-.346z",
    fill: "#FECE3F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4.421,
    fill: "#2387EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "xtmn65464c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 10,
    height: 10
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4.421,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#xtmn65464c)"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4.421,
    fill: "#2387EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.303 6.947c-.41 0-.811.037-1.198.107 2.6.466 4.552 2.418 4.552 4.756 0 2.339-1.951 4.291-4.552 4.757.387.07.787.107 1.198.107 3.175 0 5.75-2.178 5.75-4.864 0-2.685-2.575-4.863-5.75-4.863z",
    fill: "#207BD6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m7.579 10.613 9.228 2.29a4.37 4.37 0 0 0 .22-1.91L8.36 8.842a4.432 4.432 0 0 0-.781 1.77z",
    fill: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "tiir517wwd",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 11,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m7.579 10.613 9.228 2.29a4.37 4.37 0 0 0 .22-1.91L8.36 8.842a4.432 4.432 0 0 0-.781 1.77z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tiir517wwd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.02 13.004a3.77 3.77 0 0 0 .368-1.61c0-.177-.013-.35-.037-.522l-3.456-.677a3.7 3.7 0 0 1 0 2.193l3.125.616z",
    fill: "#DCDCDC"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fnh1v2ohea"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundFlagBr);
export default __webpack_public_path__ + "static/media/round-flag-br.dfe228aa12922d7ebaf401fd1f065260.svg";
export { ForwardRef as ReactComponent };